import gql from 'graphql-tag';

import tokenFragment from '../fragments/tokenFragment';

export const mutationCreateAccountProviderAccessToken = gql`
  mutation createAccountProviderAccessToken (
    $accountType: AccountType
    $enabledFeatures: [String!]
    $origin: String
    $utmSource: String
    $utmMedium: String
    $utmCampaign: String
    $utmTerm: String
    $utmContent: String
    $provider: CreateAccountOAuthProvider!
    $providerAccessToken: String!
    $providerAccessTokenVerificationHash: String!
  ) {
    createAccountProviderAccessToken (
      accountType: $accountType
      enabledFeatures: $enabledFeatures
      origin: $origin
      utmSource: $utmSource
      utmMedium: $utmMedium
      utmCampaign: $utmCampaign
      utmTerm: $utmTerm
      utmContent: $utmContent
      provider: $provider
      providerAccessToken: $providerAccessToken
      providerAccessTokenVerificationHash: $providerAccessTokenVerificationHash
    ) {
      ...tokenFragment
    }
  }
  ${tokenFragment}
`;
export default mutationCreateAccountProviderAccessToken;
